// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --background-color: #fff;
  --text-color: #000;
  --primary-color: #fff;
  --secondary-color: #fff;
  --highlight-color: #f4f4f6;
  --highlight-color-user: #6060ed;
  --modal-background: #fefefe;
}

[data-theme="dark"] {
  --background-color: #000000;
  --text-color: #f0f0f0;
  --primary-color: #111b21;
  --secondary-color: #000000;
  --highlight-color: #222e35;
  --highlight-color-user: #6868f1;
  --modal-background: #111b21;
}
.chat-container {
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  /* border: 1px solid #ccc; */
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.chat-box {
  max-height: 350px;
  overflow-y: auto;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 5px;
  /* border: 1px solid #ddd; */
}

.chat-message {
  margin: 5px 0;
  padding: 10px;
  border-radius: 10px;
}

.chat-message.user {
  color: white;
  background-color: var(--highlight-color-user);
  text-align: right;
}

.chat-message.bot {
  background-color: var(--highlight-color);
}

.chat-input {
  display: flex;
  gap: 10px;
}

.chat-input input {
  flex: 1 1;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.chat-input button {
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.chat-input button:hover {
  background-color: #0056b3;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatUs.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[":root {\n  --background-color: #fff;\n  --text-color: #000;\n  --primary-color: #fff;\n  --secondary-color: #fff;\n  --highlight-color: #f4f4f6;\n  --highlight-color-user: #6060ed;\n  --modal-background: #fefefe;\n}\n\n[data-theme=\"dark\"] {\n  --background-color: #000000;\n  --text-color: #f0f0f0;\n  --primary-color: #111b21;\n  --secondary-color: #000000;\n  --highlight-color: #222e35;\n  --highlight-color-user: #6868f1;\n  --modal-background: #111b21;\n}\n.chat-container {\n  max-width: 600px;\n  margin: 20px auto;\n  padding: 20px;\n  /* border: 1px solid #ccc; */\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.chat-box {\n  max-height: 350px;\n  overflow-y: auto;\n  margin-bottom: 10px;\n  padding: 10px;\n  background-color: #f9f9f9;\n  border-radius: 5px;\n  /* border: 1px solid #ddd; */\n}\n\n.chat-message {\n  margin: 5px 0;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.chat-message.user {\n  color: white;\n  background-color: var(--highlight-color-user);\n  text-align: right;\n}\n\n.chat-message.bot {\n  background-color: var(--highlight-color);\n}\n\n.chat-input {\n  display: flex;\n  gap: 10px;\n}\n\n.chat-input input {\n  flex: 1;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.chat-input button {\n  padding: 10px 15px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.chat-input button:hover {\n  background-color: #0056b3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
